import React from 'react';
import { connect } from 'react-redux';
import './selectionWindow.scss';

import AddRoundedIcon from '@mui/icons-material/AddRounded';

// icons 
import deleteIcon from '../../img/ico/deleteIconPopup.svg';
import closeIcon from '../../img/ico/close.svg';

import { deleteWordsFromCollection } from '../../service/requests';

import { closeSelectionWindow } from '../../actions/selectionWindow';
import { openPopup } from '../../actions/popup';
import { openNotification } from '../../actions/notification';


const mapStateToProps = state => ({
   ...state.selectionWindow
});

const mapDispatchToProps = dispatch => ({
   closeSelectionWindow: () => {
      return dispatch(closeSelectionWindow());
   },
   openPopup: (payload) => {
      return dispatch(openPopup(payload));
   },
   openNotification: (payload) => {
      return dispatch(openNotification(payload));
   }
})

const SelectionWindow = (props) => {

   const {
      showSelectionWindow,
      closeSelectionWindow,
      openPopup,
      info,
      openNotification,
   } = props;

   const {words, isSharedCollection, classId, userRole} = info;

   const onDeleteWords = async () => {
      const wordsId = words.map(word => word._id);
      try {
         await deleteWordsFromCollection(info.collectionId, wordsId );
         info.onDeleteWordsEvent(words);
         closeSelectionWindow()
      }
      catch (error) {
         console.log(error);
         openNotification({text: 'Something went wrong, try again', notificationType: 'error' });
      }

   }

   return (
      <>
         {showSelectionWindow &&
            <div className="selectedPopup">
               <div className="flex justify-start">
                  <div className="cursor-pointer p-1 flex items-center" onClick={() => closeSelectionWindow()}><img src={closeIcon} className="selectedPopup__closeBtn" /></div>
                  <div className='flex items-center'>
                     <div className="selectedPopup__numberWords">{words.length}</div>
                     <div className="hidden sm:block text-xs text-white mr-5 ml-2">{words.length === 1 ? "item" : "items"} selected</div>
                  </div>
               </div>
               <div className="flex">
                  <div className={`selectedPopup__btn ${isSharedCollection ? "mr-0" : "mr-3 md:mr-5"}`} onClick={() => openPopup({ currentPopup: "AddToCollection", info: {words: words, collectionId : info.collectionId}})} ><AddRoundedIcon fontSize="small" className="mr-2"/>Add To Collection</div>
                  {((!classId && !isSharedCollection) || (userRole === 'teacher' && !isSharedCollection)) &&
                     <div className="py-2 px-2 md:px-4 bg-deleteIcon rounded-md hover:bg-darkRed cursor-pointer transition" onClick={() => openPopup({
                        currentPopup: 'Confirmation',
                        info: {
                           title: words.length > 1 ? 'Delete words' : 'Delete word',
                           text: 'Are you sure you want to remove a word from the collection?',
                           yesBtnText: 'Yes, delete',
                           onConfirm: onDeleteWords
                        }
                     })}><img src={deleteIcon} /></div>
                  }
               </div>
            </div>
         }
      </>
   )
}

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(SelectionWindow);